import {
  AGE_GATE_POPUP_ID,
  BROADCASTING_LOCK_POPUP_ID,
  COMMON_POPUP_ID,
  FREEMIUM_LOCK_POPUP_ID,
  GEO_BLOCK_POPUP_ID,
  KIDS_LEAVE_POPUP_ID,
  PARENTAL_CODE_POPUP_ID,
  SUBSCRIPTION_POPUP_ID,
  CONTENT_RATING_POPUP_ID,
  PARENTAL_FILTER_POPUP_ID,
} from '../../modules/popups/popups.constants';

export const LOCK_POPUPS_MAP = {
  geoBlocked: GEO_BLOCK_POPUP_ID,
  contentRatingAdvisory: AGE_GATE_POPUP_ID,
  leavingKidsSection: KIDS_LEAVE_POPUP_ID,
  live: BROADCASTING_LOCK_POPUP_ID,
  freemium: FREEMIUM_LOCK_POPUP_ID,
  parentalCode: PARENTAL_CODE_POPUP_ID,
  requireSubscription: SUBSCRIPTION_POPUP_ID,
  default: COMMON_POPUP_ID,
  contentRating: CONTENT_RATING_POPUP_ID,
  parentalFilter: PARENTAL_FILTER_POPUP_ID,
};
